module.exports = __webpack_public_path__ + "img/commerzreal.07e5e298.png";